export function periodIsValid(period) {
  if (!period) return false
  const parts = period.split(' to ')
  if (parts.length === 0 || parts.length > 2) return false
  return parts.reduce((a, b) => a && dateStringIsValid(b), true)
}

export function dateStringIsValid(dateString) {
  const splits = dateString.split('-')
  return splits.length === 3 && splits[0].length === 4 && !/[A-Za-z]/.test(dateString)
}
